<template>
  <b-card class="shipping-item" :class="shipping.status.toLowerCase()" v-if="shippingTypes.length > 0 && shipping.shipping_type_id">
    <span style="position:absolute; top: 0; right: 0; padding: 0 10px" v-if="isNextDay" class="bg-dark text-light"><small><translate>Next Day</translate></small></span>
    <span style="position:absolute; top: 0; left: 0; padding: 0 10px" v-if="isPickup" class="bg-success text-light"><small><translate>PICKUP</translate></small></span>
    <span style="position:absolute; top: 0; left: 0; padding: 0 10px" v-if="isReturn" class="bg-success text-light"><small><translate>RETURN</translate></small></span>
    <b-row>
      <b-col cols="12" md="6" lg="3" class="shipping-status mb-3 mb-lg-0" order="1">

        <shipping-statuses :shipping="shipping" />

        <div>
          <strong class="shipping-id">#{{shipping.id | uuid}}</strong><br>
          <span class="shipping-date">{{shipping.status === 'DRAFT' || shipping.status === 'WAITING' || shipping.status === 'READY' ? moment.utc(shipping.created_at).tz(this.$tz).format('L LT') : moment.utc(shipping.updated_at).tz(this.$tz).format('L LT')}}</span>
        </div>
        <div v-if="shipping.external_code" v-translate="{externalCode: shipping.external_code}">
          Code: <strong>%{externalCode}</strong>
        </div>
        <div v-if="shipping.external_order_id" v-translate="{externalOrderId: shipping.external_order_id}">
          Order: <strong>%{externalOrderId}</strong>
        </div>
        <div v-if="shipping.secret_code" v-translate="{secretCode: shipping.secret_code}">
          Secret Code: <strong>%{secretCode}</strong>
        </div>

        <div v-if="isLabelable" class="mt-2">
          <b-button size="sm" style="padding: 0.1rem 1rem;" @click.stop.prevent="getShippingLabel" :title="$gettext('Get shipping PDF label')"><font-awesome-icon icon="file-pdf" size="1x" />&nbsp;&nbsp;<translate>Shipping label</translate></b-button>
        </div>

        <div v-if="isPickup || isReturn" class="mt-2">
          <b-button size="sm" variant="success" style="padding: 0.1rem 1rem;" v-b-modal.modalPickedupShippings @click.prevent.stop="$parent.$parent.$parent.getPickedupShippings(shipping.id)">
            <font-awesome-icon :icon="['far', 'eye']" size="1x" style="font-size: 16px;vertical-align: middle" />
            <translate>Picked up shippings</translate>
          </b-button>
        </div>

      </b-col>
      <b-col cols="12" md="6" lg="3" class="shipping-origin mb-3 mb-lg-0" order="3" order-lg="2">
        <h5 class="shipping-contact">{{shipping.from_contact}}</h5>
        <p>
          <span v-if="(!shipping.fields_revision || shipping.fields_revision === false) || !shipping.fields_revision_data.from || typeof shipping.fields_revision_data.from === 'object'">
            <span
              class="shipping-address"
              :class="shipping.fields_revision_data &&
                shipping.fields_revision_data.from &&
                typeof shipping.fields_revision_data.from === 'object' ? 'text-warning' : ''"
              :title="shipping.address_from.formatted_address + (shipping.from_extra && shipping.from_extra.trim() !== '' ? ' (' + shipping.from_extra.trim() + ')' : '')"><font-awesome-icon v-if="shipping.fields_revision_data &&
                shipping.fields_revision_data.from &&
                typeof shipping.fields_revision_data.from === 'object'" icon="exclamation-triangle" size="1x" /> {{shipping.address_from.formatted_address}}{{shipping.from_extra && shipping.from_extra.trim() !== '' ? ' (' + shipping.from_extra.trim() + ')' : ''}}</span>
          </span>
          <span v-if="shipping.fields_revision_data !== null && typeof shipping.fields_revision_data.from === 'string'">
            <span class="shipping-address text-danger" :title="shipping.fields_revision_data.from"><font-awesome-icon icon="exclamation-triangle" size="1x" /> {{shipping.fields_revision_data.from}}</span>
          </span>
          <div v-if="shipping.fields_revision_data && shipping.fields_revision_data.from">
            <b-button size="sm" @click.stop.prevent="setShippingToEdit" variant="primary" v-b-modal.modalFixAddressFrom style="padding: 0.1rem 1rem;" v-translate>Review Address</b-button>
          </div>
          <span>
            <span v-if="shipping.from_email">
              {{shipping.from_email}}
            </span>
            <span v-show="shipping.from_phone && editing !== 'from_phone'">
              <br>
              {{shipping.from_phone}}
              <b-button v-if="isEditable" size="sm" variant="link" style="padding:0 .5rem" @click.prevent="Object.assign(originalShipping, shipping); editing = 'from_phone'" :disabled="editing !== null"><font-awesome-icon icon="edit" /></b-button>
            </span>
            <b-input-group @click.prevent.stop class="my-1" size="sm" v-show="shipping.from_phone && editing === 'from_phone'">
              <cleave ref="toPhone" @input="updatePatch(patchField, 'from_phone', $event)" :options="{ phone: true, phoneRegionCode: this.$cookies.get('country').toLowerCase() }" class="form-control" v-model="shipping.from_phone" autocomplete="nope"></cleave>
              <b-input-group-append>
                <b-button size="sm" variant="success" @click.prevent="patchShipping"><font-awesome-icon class="text-white" icon="check" size="sm" /></b-button>
                <b-button size="sm" variant="danger" @click.prevent="Object.assign(shipping, originalShipping); patchField = {}; editing = null">×</b-button>
              </b-input-group-append>
            </b-input-group>
          </span>
        </p>
      </b-col>
      <b-col cols="12" md="6" lg="3" class="shipping-destination mb-3 mb-lg-0" order="4" order-lg="3">
        <h5 class="shipping-contact">{{shipping.to_contact}}</h5>
        <span v-if="(!shipping.fields_revision || shipping.fields_revision === false) || !shipping.fields_revision_data.to || typeof shipping.fields_revision_data.to === 'object'">
          <span
            class="shipping-address"
            :class="shipping.fields_revision_data &&
              shipping.fields_revision_data.to &&
              typeof shipping.fields_revision_data.to === 'object' ? 'text-warning' : ''"
            :title="shipping.address_to.formatted_address + (shipping.to_extra && shipping.to_extra.trim() !== '' ? ' (' + shipping.to_extra.trim() + ')' : '')"><font-awesome-icon v-if="shipping.fields_revision_data &&
              shipping.fields_revision_data.to &&
              typeof shipping.fields_revision_data.to === 'object'" icon="exclamation-triangle" size="1x" /> {{shipping.address_to.formatted_address}}{{shipping.to_extra && shipping.to_extra.trim() !== '' ? ' (' + shipping.to_extra.trim() + ')' : ''}}</span>
        </span>
        <span v-if="shipping.fields_revision_data !== null && typeof shipping.fields_revision_data.to === 'string'">
          <span class="shipping-address text-danger" :title="shipping.fields_revision_data.to"><font-awesome-icon icon="exclamation-triangle" size="1x" /> {{shipping.fields_revision_data.to}}</span>
        </span>
        <div v-if="shipping.fields_revision_data && shipping.fields_revision_data.to">
          <b-button size="sm" @click.stop.prevent="setShippingToEdit" variant="primary" v-b-modal.modalFixAddressTo style="padding: 0.1rem 1rem;" v-translate>Review Address</b-button>
        </div>
        <span>
          <span v-if="shipping.to_email">
            {{shipping.to_email}}
          </span>
          <span v-if="shipping.to_phone">
            <br>
            {{shipping.to_phone}}
          </span>
        </span>
        <p><b-button v-if="isEditable && (!shipping.fields_revision || shipping.fields_revision === false)" size="sm" @click.stop.prevent="shippingEdit = shipping" variant="primary" v-b-modal="'modalEditTo' + shipping.id" style="padding: 0.1rem 1rem;" v-translate>Edit Destination Information</b-button></p>
      </b-col>
      <b-col cols="12" md="6" lg="3" class="shipping-actions text-right ml-n5 mb-3 mb-lg-0 align-self-center" style="padding-left: 35px;" order="2" order-lg="4">
        <b-row v-if="shipping.courier !== null && !isCancelable && this.shipping.status !== 'DELIVERED'" class="shipping-courier h-100" style="padding:10px 0;" align-v="center">
          <b-col cols="8" class="align-self-center text-left text-lg-right" order="2" order-lg="1">
            <h5>{{shipping.courier.name}} <small v-if="shipping.courier.courier_available && shipping.courier.courier_available.user.tin"><small>({{ shipping.courier.courier_available.user.tin }})</small></small></h5>
            <strong class="plate" v-if="shipping.courier.courier_available && shipping.courier.courier_available.vehicle && shipping.courier.courier_available.vehicle.plate_number">{{ shipping.courier.courier_available.vehicle.plate_number }}</strong>
          </b-col>
          <b-col cols="3" sm="2" md="3" lg="4" class="align-self-center" order="1" order-lg="2">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded-circle profile-image" alt="img" :style="'width: 60px; height: 60px; background-image: url(' + (shipping.courier.profile_picture || 'https://www.gravatar.com/avatar/default?s=60&r=pg&d=mm') + ')'" />
          </b-col>
        </b-row>
        <b-row v-if="shipping.courier !== null && !isCancelable && this.shipping.status === 'DELIVERED'" class="shipping-courier h-100" style="padding:10px 0;" align-v="center">
          <b-col cols="8" class="align-self-center text-left text-lg-right" order="2" order-lg="1">
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-right">
            <b-button variant="outline-success" block  size="sm" v-if="canChangeToReady" @click.stop.prevent="setAsReady" class="align-self-center my-1" v-translate>It's now ready to ship</b-button>
            <b-button variant="outline-danger" block size="sm" v-if="isCancelable" @click.stop.prevent="cancelShipping" class="align-self-center my-1" v-translate>Cancel this shipping</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" style="padding-left: 35px;" v-if="shipping.status !== 'DELIVERED' && shipping.status !== 'CANCELED' && shipping.status !== 'TOBERETURNED' && shipping.status !== 'RETURNED'">
        <hr>
        <b-form-row>
          <b-col>
            <translate class="d-none">Copy to Clipboard</translate>
            <a @click.stop :href="host + '/external/' + shipping.id" target="_blank"><translate>Receiver's tracking link</translate></a> <a href="#" @click.stop.prevent="copyToClipboard(host + '/external/' + shipping.id)" class="text-secondary" :title="this.$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
            <div v-if="(shipping.fields_revision || shipping.fields_revision === true)">
              <a @click.stop :href="host + '/external/' + shipping.id + '?hash=' + shipping.hash" target="_blank"><translate>Receiver's edit address link</translate></a> <a href="#" @click.stop.prevent="copyToClipboard(host + '/external/' + shipping.id + '?hash=' + shipping.hash, 'edit')" class="text-secondary" :title="this.$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
            </div>
          </b-col>
          <b-col class="text-right" v-if="itemsQuantity">
            <a href="#" class="px-1" :class="itemsQuantity > 1 ? 'text-secondary' : ''" :style="itemsQuantity > 1 ? 'background: #ffc;' : ''" @click.prevent v-b-modal="'modalItems' + shipping.id" :translate-n="itemsQuantity" translate-plural="%{ itemsQuantity } items" v-translate>%{ itemsQuantity } item</a>
          </b-col>
        </b-form-row>
      </b-col>
      <b-col cols="12" style="padding-left: 35px" v-else>
        <div v-if="itemsQuantity">
          <hr>
          <b-form-row>
            <b-col class="text-right">
              <a href="#" class="px-1" :class="itemsQuantity > 1 ? 'text-secondary' : ''" :style="itemsQuantity > 1 ? 'background: #ffc;' : ''" @click.prevent v-b-modal="'modalItems' + shipping.id" :translate-n="itemsQuantity" translate-plural="%{ itemsQuantity } items" v-translate>%{ itemsQuantity } item</a>
            </b-col>
          </b-form-row>
        </div>
      </b-col>
    </b-row>
    <div class="d-none">
      <translate>Get shipping PDF label</translate>
    </div>

    <b-modal :id="'modalItems' + shipping.id" :ref="'modalItems' + shipping.id" :hide-footer="true">
      <div slot="modal-title" v-translate>Shipping Items</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-row v-for="(item, index) in items" :key="index">
        <b-col cols="10">
          - {{item.description}}
        </b-col>
        <b-col>
          {{item.quantity}} u.
        </b-col>
        <b-col cols="12" v-if="item.serial_number">
          <small v-translate="{serialNumbers: item.serial_number}">-- Serial Numbers: %{serialNumbers}</small>
        </b-col>
        <b-col cols="12">
          <hr>
        </b-col>
      </b-row>
    </b-modal>


    <b-modal size="lg" :id="'modalEditTo' + shipping.id" :ref="'modalEditTo' + shipping.id" :hide-footer="true" @hide="resetEditing">
      <div slot="modal-title" v-translate>Edit Destination Information</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-form @submit.stop.prevent="editTo">
        <b-row>
          <div class="form-group col-sm-8">
            <label for="from_address" v-translate>Destination Address</label>
            <div class="input-group">
              <address-autocomplete v-if="shippingEdit.address_to" :pre-query="shippingEdit.address_to.formatted_address" @selected="selectedTo" @input="shippingEdit.to_place_id = null" static-items :minCharacter="4" />
            </div>
            <small class="form-text text-muted" v-translate>We use Google to validate all addresses, please keep it in mind when you enter yours.</small>
            <input type="hidden" id="to_place_id" name="to_place_id" v-model="shippingEdit.to_place_id">
          </div>
          <div class="form-group col-sm-4">
            <label for="to_extra" v-translate>Floor, door, etc.</label>
            <div class="input-group">
              <b-form-input id="to_extra" name="to_extra" v-model="shippingEdit.to_extra" class="col-12 form-control" />
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="form-group col-sm-12">
            <label for="to_contact" v-translate>Destination Contact Name</label>
            <div class="input-group">
              <b-form-input id="to_contact" name="to_contact" v-model="shippingEdit.to_contact" required />
            </div>
          </div>
          <div class="form-group col-sm-6">
            <label for="to_email" v-translate>Destination Contact E-mail</label>
            <div class="input-group">
              <b-form-input trim id="to_email" name="to_email" v-model="shippingEdit.to_email" />
            </div>
          </div>
          <div class="form-group col-sm-6">
            <label for="to_phone" v-translate>Destination Contact Phone</label>
            <div class="input-group">
              <b-form-input v-model="shippingEdit.to_phone" />
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="form-group col-sm-6">
            <label for="from_contact">
              <translate>Special instructions</translate> <em class="text-info"><small v-translate>(up to 255 characters)</small></em>
            </label>
            <div class="input-group">
              <b-form-textarea id="to_meta" name="to_meta" v-model="shippingEdit.to_meta" :rows="3" :max-rows="6" @input="countdown('to_meta', 255)" :state="invalid.to_meta" /><br>
            </div>
            <p class='text-right' v-bind:class="{'text-danger': invalid.to_meta === false }"><small>{{limits.to_meta}}</small></p>
            <small class="form-text text-muted"><span v-translate="{courierI18n: this.courierI18n}">Do you have any special instruction for our %{courierI18n} on delivery?</span><br>
            <translate>i.e.</translate> <em v-translate>The door bell is not working</em></small>
          </div>
        </b-row>
        <div class="text-right form-group col-12 form-actions">
          <b-button type="submit" variant="primary" size="lg" v-translate>Update information</b-button>
          <b-button variant="outline-primary" size="lg" @click.prevent="$refs['modalEditTo' + shipping.id].hide()" v-translate>Cancel</b-button>
        </div>
      </b-form>
    </b-modal>

    <div class="d-none">
      <translate>Quick view address map on new window</translate>
    </div>
  </b-card>
</template>
<script>
import AddressMixins from '@/mixins/address.mixin.js'
import { mapGetters } from 'vuex'
import AddressAutocomplete from '@/components/AddressAutocomplete'
import ShippingStatuses from '@/components/ShippingStatuses'
import Cleave from 'vue-cleave'

export default {
  name: 'ShippingListItem',
  components: {
    AddressAutocomplete,
    ShippingStatuses,
    Cleave
  },
  data() {
    return {
      step: 2,
      config: this.$appConfig,
      apiKey: this.$appConfig.maps.api_key,
      rating: 0,
      interval: null,
      visits: 0,
      statusReasonsStrings: {
        'error': this.$gettext('Taken by mistake'),
        'technical_issue': this.$gettext('Technical issue'),
        'absent_client': this.$gettext('Absent client'),
        'incorrect_address': this.$gettext('Wrong address'),
        'unavailable_product': this.$gettext('Unavailable product'),
        'unrecognized': this.$gettext('Shipping not accepted'),
        'wrong_size': this.$gettext('Wrong package size'),
        'rejected': this.$gettext('Shipping not expected')
      },
      host: window.location.origin,
      shippingEdit: {},
      invalid: {},
      limits: {},
      originalShipping: {},
      editing: null,
      patchField: {},
      items: []
    }
  },
  props: {
    shipping: {
      type: Object,
      required: true
    },
    actions: {
      type: Boolean,
      required: false,
      default: false
    },
    isPreview: {
      type: Boolean,
      required: false,
      default: false
    },
    shippingTypes: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isScheduled() {
      return this.shipping.scheduled_date && this.moment.utc(this.shipping.scheduled_date) > this.moment().utc()
    },
    isCancelable() {
      return this.shipping.status === 'DRAFT' ||
        this.shipping.status === 'READYATSTORE' ||
        this.shipping.status === 'READY' ||
        this.shipping.status === 'WAITING' ||
        this.isUnavailable ||
        this.isAbsent
        // || (this.shipping.status === 'CONFIRMED' && this.moment.utc(this.shipping.updated_at) > this.moment().subtract(2, 'minutes').utc())
    },
    isLabelable() {
      return (
        this.shipping.status === 'DRAFT' ||
        this.shipping.status === 'READYATSTORE' ||
        this.shipping.status === 'READY' ||
        this.shipping.status === 'WAITING' ||
        this.shipping.status === 'CONFIRMED' ||
        this.shipping.status === 'ATPICKUPPOINT'
      ) && (
        !this.shipping.fields_revision ||
        (
          this.$store.getters.profile.company.settings.findIndex(x => x.name === 'label_wrong_address') !== -1 &&
          this.$store.getters.profile.company.settings.find(x => x.name === 'label_wrong_address').pivot.value === '1'
        )
      )
    },
    canChangeToReady() {
      return this.isAbsent || this.isUnavailable || this.shipping.status === 'DRAFT' && !this.shipping.fields_revision
    },
    isAbsent() {
      return this.shipping.status_history.length > 0 &&
        this.shipping.status_history[0].status === 'INCIDENCE' &&
        this.shipping.status_history[0].shipping_status_reason !== null &&
        this.shipping.status_history[0].shipping_status_reason.name === 'absent_client' &&
        this.shipping.status_history[0].shipping_status_reason.event === 'PICKEDUP'
    },
    isUnavailable() {
      return this.shipping.status_history.length > 0 && this.shipping.status_history[0].status === 'INCIDENCE' && this.shipping.status_history[0].details.reason === 'unavailable_product'
    },
    isEditable() {
      return this.shipping.status !== 'DELIVERED' &&
        this.shipping.status !== 'CANCELED' &&
        this.shipping.status !== 'RETURNED'
    },
    isNextDay() {
      return this.shippingTypes.findIndex(x => x.name === 'next_day') !== -1 && this.shipping.shipping_type_id === this.shippingTypes.find(x => x.name === 'next_day').id
    },
    isPickup() {
      return this.shippingTypes.findIndex(x => x.name === 'pickup') !== -1 && this.shipping.shipping_type_id === this.shippingTypes.find(x => x.name === 'pickup').id
    },
    isReturn() {
      return this.shippingTypes.findIndex(x => x.name === 'return') !== -1 && this.shipping.shipping_type_id === this.shippingTypes.find(x => x.name === 'return').id
    },
    itemsQuantity() {
      return this.items ? this.items.reduce((a, b) => a + (parseInt(b.quantity) || 0), 0) : null
    },
    ...mapGetters([
      'currentUser',
      'isAuthenticated'
    ])
  },
  mixins: [AddressMixins],
  created() {
    if (this.shipping.status === 'INCIDENCE') {
      for (let i = 0; i < this.shipping.status_history.length; i++) {
        if (this.shipping.status_history[i].details && (this.shipping.status_history[i].details.reason === 'absent_recipient' || this.shipping.status_history[i].details.reason === 'absent_client')) {
          this.visits++
        }
      }
    }

    if (this.shipping.items && this.shipping.items.length > 0) {
      this.items = this.shipping.items.map(x => {
        if (x.item) {
          x.item.quantity = x.item.quantity || 1
          x.item.description = x.item.description || x.item.name || this.$gettext('No item description')
          x.item.serial_number = x.item.serial_number && x.item.serial_number.length > 0 ? x.item.serial_number.join(', ') : null
        } else {
          x.quantity = x.quantity || 1
          x.description = x.description || x.name || this.$gettext('No item description')
          x.serial_number = x.serial_number && x.serial_number.length > 0 ? x.serial_number.join(', ') : null
        }

        return {
          description: x.description || x.item.description || this.$gettext('No item description'),
          quantity: x.quantity || x.item.quantity || 1,
          serial_number: x.serial_number || (x.item && x.item.serial_number ? x.item.serial_number : null)
        }
      })
    } else if (this.shipping.meta && this.shipping.meta.items && this.shipping.meta.items.length > 0) {
      this.items = this.shipping.meta.items.map(x => {
        if (x.item) {
          x.item.quantity = x.item.quantity || 1
          x.item.description = x.item.description || x.item.name || this.$gettext('No item description')
          x.item.serial_number = x.item.serialNumbers && x.item.serialNumbers.length > 0 ? x.item.serialNumbers.join(', ') : null
        } else {
          x.quantity = x.quantity || 1
          x.description = x.description || x.name || this.$gettext('No item description')
          x.serial_number = x.serialNumbers && x.serialNumbers.length > 0 ? x.serialNumbers.join(', ') : null
        }

        return {
          description: x.description || x.item.description || this.$gettext('No item description'),
          quantity: x.quantity || x.item.quantity || 1,
          serial_number: x.serial_number || (x.item && x.item.serial_number ? x.item.serial_number : null)
        }
      })
    } else {
      this.items = []
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    setShippingToEdit() {
      this.$parent.$parent.$parent.shippingEdit = this.shipping
    },
    setRating(rating) {
      let params = {
        value: rating,
        comment: ''
      }
      this.$http.post(this.$appConfig.api.baseUrl + 'shippings/' + this.shipping.id + '/rate', params)
        .then(response => {
          this.rating = rating
          this.shipping.rates = [
            {
              value: rating
            }
          ]
        })
    },
    cancelShipping() {
      if (confirm(this.$gettext('Are you sure you want to CANCEL the shipping with ID #') + this.shipping.id + '?') === true) {
        let params = {
          status: 'CANCELED',
          details: {
            reason: 'canceled_by_client'
          },
          meta: 'Canceled by client'
        }
        this.$http.post(this.$appConfig.api.baseUrl + 'shippings/' + this.shipping.id + '/status', params)
          .then(response => {
          })
      }
    },
    setAsReady() {
      if (confirm(this.$gettextInterpolate(this.$gettext('Is the shipping READY TO BE PICKED UP by our %{courierI18n}?'), {courierI18n: this.courierI18n})) === true) {
        let params = {}
        if (this.profile.company && this.profile.company.settings.findIndex(x => x.name === 'via_warehouse') !== -1 && this.profile.company.settings.find(x => x.name === 'via_warehouse').pivot.value === '1') {
          params.status = 'READYATSTORE'
        } else {
          params.status = 'READY'
        }
        this.$http.post(this.$appConfig.api.baseUrl + 'shippings/' + this.shipping.id + '/status', params)
          .then(response => {
          })
      }
    },
    getShippingLabel() {
      this.$http.get(this.$appConfig.api.baseUrl + 'shippings/' + this.shipping.id + '/label')
        .then(response => {
          let labelUrl = response.body.label
          window.open(labelUrl, 'label__' + this.shipping.id)
        })
    },
    copyToClipboard(str, type) {
      const el = document.createElement('textarea')
      el.value = str
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      try {
        document.execCommand('copy')
        let mssg
        switch (type) {
          case 'edit':
            mssg = this.$gettext('The External Edit URL has been copied to Clipboard')
            break
          default:
            mssg = this.$gettext('The Tracking URL has been copied to Clipboard')
        }
        this.makeToast(this.$gettext('Notice'), mssg, 'success')
      } catch (e) {
        let mssg
        switch (type) {
          case 'edit':
            mssg = this.$gettext('The External Edit URL could not be copied to Clipboard')
            break
          default:
            mssg = this.$gettext('The Tracking URL could not be copied to Clipboard')
        }
        this.makeToast(this.$gettext('Warning'), mssg, 'danger')
      }
      document.body.removeChild(el)
    },
    makeToast(title, mssg, variant = 'info', append = false) {
      this.$bvToast.toast(mssg, {
        title: title,
        autoHideDelay: 5000,
        appendToast: append,
        variant: variant
      })
    },
    selectedTo(item) {
      if (item.reference) {
        this.shippingEdit.to_contact = item.contact
        this.shippingEdit.to_email = item.email
        if (item.phone) {
          this.$refs.toPhone.cleave.setRawValue(item.phone.replace(/\s/g, ''))
        } else {
          this.$refs.toPhone.cleave.setRawValue('')
        }
        this.shippingEdit.to_extra = item.address_extra
        this.checkToPlace({id: item.place_id, main_text: item.place.formatted_address, secondary_text: ''})
      } else {
        this.checkToPlace(item)
      }
    },
    resetEditing() {
      this.shippingEdit = {}
    },
    async checkToPlace(place) {
      await this.checkPlace(place)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.toAddress = this.theCheckedAddress.formatted_address
          this.shippingEdit.to_place_id = this.theCheckedAddress.id
          this.theCheckedAddress = {}
        }
      })
    },
    handleAddressTo() {
      if (this.shippingEdit.to_place_id) {
        this.$http.patch(this.$appConfig.api.baseUrl + 'users/' + this.$store.getters.profile.id + '/shippings/' + this.shippingEdit.id, {to_place_id: this.shippingEdit.to_place_id})
          .then(response => {
            this.$emit('shippingupdated', this.shipping)
            this.$refs['modalFixAddressTo' + this.shippingEdit.id].hide()
            this.shippingEdit = {}
            this.refreshTable(this.filters)
          })
      }
    },
    editTo() {
      console.log(this.shippingEdit)
      let editing = {
        to_contact: this.shippingEdit.to_contact,
        to_email: this.shippingEdit.to_email,
        to_extra: this.shippingEdit.to_extra,
        to_meta: this.shippingEdit.to_meta,
        to_phone: this.shippingEdit.to_phone,
        to_place_id: this.shippingEdit.to_place_id
      }
      this.$http.patch(this.$appConfig.api.baseUrl + 'users/' + this.$store.getters.profile.id + '/shippings/' + this.shippingEdit.id, editing)
        .then(response => {
          this.$emit('shippingupdated', this.shipping)
          this.$refs['modalEditTo' + this.shippingEdit.id].hide()
          this.shippingEdit = {}
          // this.refreshTable(this.filters)
        })
    },
    updatePatch(obj, prop, event) {
      this.patchField[prop] = event
    },
    patchShipping() {
      this.$http.patch(this.$appConfig.api.baseUrl + 'shippings/' + this.shipping.id, this.patchField)
        .then(response => {
          this.originalShipping = {}
          this.patchField = {}
          this.editing = null
          this.searchQuery = ''
          this.$parent.$parent.$parent.clearInterval()
          this.$parent.$parent.$parent.setInterval()
        })
    },
    countdown(value, limit) {
      this.limits[value] = this.shippingEdit[value] ? limit - this.shippingEdit[value].length : null
      this.invalid[value] = this.shippingEdit[value] ? this.shippingEdit[value].length <= limit : null
    }
  }
}

</script>
